<template>
  <div class="third">
    <div class="third-formOne adhibition">
      <div class="formOne-btn">
        <div class="btn-left">
          <!-- <span class="left-back-icon" @click="goBack">
            <i class="el-icon-arrow-left"></i>
            <span class="left-back-title">返回</span>
          </span>
          <span class="left-back-shu">
            <span class="left-back-shu-content"></span>
          </span>-->
          <span class="left-back-content">消息联系人配置</span>
          <!-- <span v-if="IDlist !== ''" class="left-back-content">编辑班级信息</span> -->
        </div>
        <div class="btn-right">
          <el-button class="btn-two" type="default" @click="Reset">重置</el-button>
          <el-button
            class="btn-two"
            type="primary"
            @click="updateOrganizationFN"
            v-el-disabel-repeat-click
          >保存</el-button>
        </div>
      </div>

      <div class="formOne-forms" style="width:60%;float:left;">
        <div class="forms-one" style="margin-top: 45px;">
          <div class="one-list">
            <span class="organization-sepec-notice"><i class="el-icon-warning"></i>各栏目下的数据来源不可修改，这里仅支持修改栏目名字，以适应校情</span>
          </div>
        </div>
        <div class="forms-one">
          <div class="one-title">
            <div class="title-left">
              <span class="left-icon">
                <i class="el-icon-s-operation"></i>
              </span>
              <span class="left-content">学生栏目名称</span>
            </div>
          </div>
          <div class="one-list">
            <el-form :rules="rules" ref="ruleForm" label-width="86px">
              <el-form-item
                v-for="(item,index) in student"
                :key="index"
                :label="String(index+1)+'、'"
                prop="stuNumber"
              >
                <el-input
                  style="margin-right:8px;"
                  class="item-input"
                  :maxlength="10"
                  v-model.trim="item.value"
                  placeholder="请输入"
                ></el-input>
                <el-input
                  class="list-input"
                  :maxlength="50"
                  v-model.trim="item.valueEn"
                  placeholder="英文版，不填默认使用中文版内容"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="forms-one">
          <div class="one-title">
            <div class="title-left">
              <span class="left-icon">
                <i class="el-icon-s-operation"></i>
              </span>
              <span class="left-content">教工栏目名称</span>
            </div>
          </div>
          <div class="one-list">
            <el-form :rules="rules" ref="ruleForm" label-width="86px">
              <el-form-item
                v-for="(item,index) in teacher"
                :key="index"
                :label="String(index+1)+'、'"
                prop="stuNumber"
              >
                <el-input
                  style="margin-right:8px;"
                  class="item-input"
                  :maxlength="10"
                  v-model.trim="item.value"
                  placeholder="请输入"
                ></el-input>
                <el-input
                  class="list-input"
                  :maxlength="50"
                  v-model.trim="item.valueEn"
                  placeholder="英文版，不填默认使用中文版内容"
                ></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
        <div class="forms-one">
          <div class="one-title">
            <div class="title-left">
              <span class="left-icon">
                <i class="el-icon-s-operation"></i>
              </span>
              <span class="left-content">电话号码查看权限（包括手机号、备用号码）</span>
            </div>
          </div>
          <div class="one-list">
            <el-form :rules="rules" ref="ruleForm" label-width="86px">
              <el-form-item
                label="教工-学生"
                prop="teacher_look_student"
              >
                <el-select
                    v-model="teacher_look_student"
                    class="list-input"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, index) in options2"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item
                label="教工-教工"
                prop="teacher_look_teacher"
              >
                <el-select
                    v-model="teacher_look_teacher"
                    class="list-input"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, index) in options1"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item
                label="学生-教工"
                prop="student_look_teacher"
              >
                <el-select
                    v-model="student_look_teacher"
                    class="list-input"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, index) in options3"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item
                label="学生-学生"
                prop="student_look_student"
              >
                <el-select
                    v-model="student_look_student"
                    class="list-input"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="(item, index) in options4"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
              </el-form-item>
              <el-form-item
                label="其他用户"
                prop="student_look_student"
              >
                <div style="color: #2e4057;font-size:12px;line-height: 26px;" >与学生、教工之间，仅可查看好友的电话号码</div>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="phon-right">
        <img class="phon-right-img" src="@/assets/zzjglm.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
import {
  organizationDetails,
  updateOrganization
} from "@/store/appconfig/organization"; //我的

export default {
  name: "formSeven",
  data() {
    return {
      rules: {
        schoolId: [
          { required: true, message: "请输入学校代码", trigger: "blur" }
        ],
        schoolName: [
          { required: true, message: "请输入学校名称", trigger: "blur" }
        ]
      },
      //===============================
      student: [], //学生栏
      teacher: [], //教工栏
    //   teaTelRule: '2', // 教工号码查看
    //   stuTelRule: '2', // 学生号码查看
      teacher_look_student:"RELATED",//教工-学生
      teacher_look_teacher:"FRIEND_ONLY",//教工-教工
      student_look_student:"FRIEND_ONLY",//学生-学生
      student_look_teacher:"FRIEND_ONLY",//学生-教工
      options1:[
          {
           value: 'ALL',
           label: '可查看联系人列表中全部教工的电话号码'
          },
          {
           value: 'RELATED',
           label: '仅可查看部门同事和教工好友的电话号码'
          },
          {
           value: 'FRIEND_ONLY',
           label: '仅可查看教工好友的电话号码'
          },
      ],
      options2:[
          {
           value: 'RELATED',
           label: '可查看联系人中全部学生的电话号码'
          },
          {
           value: 'FRIEND_ONLY',
           label: '仅可查看学生好友的电话号码'
          }
      ],
      options3:[
          {
           value: 'RELATED',
           label: '可查看联系人列表中全部教工的电话号码'
          },
          {
           value: 'FRIEND_ONLY',
           label: '仅可查看教工好友的电话号码'
          }
      ],
      options4:[
          {
           value: 'RELATED',
           label: '可查看联系人列表中全部学生的电话号码'
          },
          {
           value: 'FRIEND_ONLY',
           label: '仅可查看学生好友的电话号码'
          }
      ],
    };
  },
  created() {
    this.organizationDetailsFN();
  },
  methods: {
    //重置
    Reset() {
      this.organizationDetailsFN();
    },
    //获取显示
    organizationDetailsFN() {
      try {
        organizationDetails().then(res => {
          const data = res.data;
          console.log(res, '222')
          if (data.status === 1000) {
            this.student = data.result.student;
            this.teacher = data.result.teacher;
            this.teacher_look_student = data.result.telLook.teacher_look_student || 'RELATED';
            this.teacher_look_teacher = data.result.telLook.teacher_look_teacher || "FRIEND_ONLY";
            this.student_look_student = data.result.telLook.student_look_student || 'FRIEND_ONLY';
            this.student_look_teacher = data.result.telLook.student_look_teacher || 'FRIEND_ONLY';
            // console.log(this.student);
          }else {
            this.$message({
              type: "error",
              message: data.msg
            });
          }
        });
      } catch (err) {
        console.log(err);
      }
    },
    //保存
    updateOrganizationFN() {
      console.log("进啦了");
      try {
        let next = true;
        let setData = [];
        // setData = this.teacher.concat(this.student);
        setData.push.apply(setData, this.student);
        setData.push.apply(setData, this.teacher);
        // console.log(setData);
        setData.forEach(item => {
          if (item.value == "") {
            next = false;
          }
        });
        if (next) {
          const params = {
            oranizationBasic: [],
            telLook: {
            }
          }
          params.oranizationBasic = setData
          params.telLook.teacher_look_student = this.teacher_look_student
          params.telLook.teacher_look_teacher = this.teacher_look_teacher
          params.telLook.student_look_student = this.student_look_student
          params.telLook.student_look_teacher = this.student_look_teacher
          updateOrganization(params).then(res => {
            const data = res.data;
            if (data.status === 1000) {
              this.$message.success("操作成功");
            }else {
            this.$message({
              type: "error",
              message: data.msg
            });
          }
          });
        } else {
          this.$message.error("请填写完整信息");
        }
      } catch (err) {
        console.log(err);
      }
    }
    //==========================================================
    //上传图片
  }
};
</script>

<style lang="scss">
.organization-sepec-notice {
  line-height: 32px;
  font-size: 12px;
  color: #FF4D4F;
  .el-icon-warning {
    margin-right: 8px;
  }
}
.phon-right{
  position: relative;
  // border:1px solid red;
  width: 40%;
  display: inline-block;
  height:calc(100vh - 102px);
  border-left: 1px solid #dcdee2;
  img{
    // border: 1px solid red;
    width: 389px;
    height: 669px;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;

  }
}
</style>
